import { render, staticRenderFns } from "./ScoreCardComponent.vue?vue&type=template&id=513e922d"
import script from "./ScoreCardComponent.vue?vue&type=script&lang=js"
export * from "./ScoreCardComponent.vue?vue&type=script&lang=js"
import style0 from "./ScoreCardComponent.vue?vue&type=style&index=0&id=513e922d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports